import { render, staticRenderFns } from "./RecordDownload.vue?vue&type=template&id=e48a47b2&"
import script from "./RecordDownload.vue?vue&type=script&lang=js&"
export * from "./RecordDownload.vue?vue&type=script&lang=js&"
import style0 from "./RecordDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports